module.exports = __webpack_public_path__ + "static/media/6.728af8bd.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/6.jpg
 ** module id = 153
 ** module chunks = 0
 **/